import {
    LOAD_PROJECT_DETAILS,
    LOAD_PROJECT_SUCCESS,
    LOAD_PROJECT_ERROR,

    LOAD_PHASE_DETAILS,
    LOAD_PHASE_SUCCESS,
    LOAD_PHASE_ERROR,

    LOAD_DROPDOWN_PROJECT,
    LOAD_DROPDOWN_PROJECT_SUCCESS,
    LOAD_DROPDOWN_PROJECT_ERROR
} from "./constant"

export function loadProjectDetails(projectarg){
    return{
        type:LOAD_PROJECT_DETAILS,
        projectarg
        }
}

export function loadProjectSuccess(projectlist,success){
    return{
        type:LOAD_PROJECT_SUCCESS,
        projectlist,
        success
    }
}

export function loadProjectError(error){
    return{
        type:LOAD_PROJECT_ERROR,
        error
    }
}

export function loadPhaseDetails(projectarg){
    return{
        type:LOAD_PHASE_DETAILS,
        projectarg,
    }
}

export function loadPhaseSuccess(phaselist,success){
    return{
        type:LOAD_PHASE_SUCCESS,
        phaselist,
        success,
    }
}

export function loadPhaseError(error){
    return{
        type:LOAD_PHASE_ERROR,
        error,
    }
}

export function loadDropdownProject(projectarg){
    return{
        type:LOAD_DROPDOWN_PROJECT,
        projectarg,
    }
}

export function loadDropdownSuccess(dropdownlist, success){
    return{
        type:LOAD_DROPDOWN_PROJECT_SUCCESS,
        dropdownlist,
        success,
    }
}

export function loadDropdownError(error){
    return{
        type:LOAD_DROPDOWN_PROJECT_ERROR,
        error,
    }
}

const actions = {
    loadProjectDetails,
    loadProjectSuccess,
    loadProjectError,
    loadPhaseDetails,
    loadPhaseSuccess,
    loadPhaseError,
    loadDropdownProject,
    loadDropdownSuccess,
    loadDropdownError,
}

export default actions;